'use client';

import React from 'react';
import { PageProps } from '../../types/page';
import PagesProvider, { ParsedQuery } from '../../context/PagesProvider';
import {
  useParams,
  usePathname,
  useRouter,
  useSearchParams,
} from 'next/navigation';
import PreloadResources from '../_lib/frontend/head/preload-resources';
import { getCookie } from 'cookies-next';
import { NEOID_STATE_COOKIE } from '@osmosis/shared/constants/cookies';

type Props = PageProps;

/**
 * Wrap page content with app page provider.
 */
const AppPage = (props: Props) => {
  const { user, children } = props;

  const neoIDState = getCookie(NEOID_STATE_COOKIE);
  if (!user && neoIDState === 'unchecked') {
    window.location.href = `/neologinnp?redirect=${
      window.location.pathname + window.location.search
    }`;
  }
  // Get app router
  const appRouter = useRouter();
  const params = useParams();
  const searchParams = useSearchParams();

  const pathname = usePathname();

  // Replicate the legacy useRouter().query object, which contains both 'params' and 'searchParams'
  const query = Object.fromEntries(
    new URLSearchParams(searchParams?.toString() || ''),
  );

  // Replicate 'asPath' property from legacy router (includes query string)
  const searchParamsString = searchParams?.toString() || '';
  const asPath = `${pathname}${
    searchParamsString ? `?${searchParamsString}` : ''
  }`;

  return (
    <PagesProvider
      routerQuery={(query as ParsedQuery) || {}}
      routerParams={(params as ParsedQuery) || {}}
      routerPathname={pathname}
      routerBack={appRouter.back}
      routerPush={appRouter.push}
      asPath={asPath}
      routerRefresh={appRouter.refresh}
    >
      <PreloadResources />
      {children}
    </PagesProvider>
  );
};

export default AppPage;
